<template>
    <v-select
        outlined
        hide-details
        append-icon="expand_more"
        v-bind="$attrs"
        v-on="$listeners"/>
</template>

<script>
export default {
    name: 'SelectField'
}
</script>

<style lang="scss" scoped>

</style>
